import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_4562_7843)">
      <path
        d="M7 13.25C10.4518 13.25 13.25 10.4518 13.25 7C13.25 3.54822 10.4518 0.75 7 0.75C3.54822 0.75 0.75 3.54822 0.75 7C0.75 10.4518 3.54822 13.25 7 13.25Z"
        fill="white"
        stroke="#54A1FC"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 7.625L6.31818 9.5C7.17375 7.04232 7.88628 5.96386 9.5 4.5"
        stroke="#54A1FC"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4562_7843">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const SuccessAlert = memo(ForwardRef);
export default SuccessAlert;
